import { render } from "./ApplyJobVacancy.vue?vue&type=template&id=5c4fbc01&scoped=true"
import script from "./ApplyJobVacancy.vue?vue&type=script&lang=js"
export * from "./ApplyJobVacancy.vue?vue&type=script&lang=js"

import "./public-job-vacancy.scss?vue&type=style&index=0&id=5c4fbc01&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c4fbc01"]])

export default __exports__